import React, { useEffect, useState } from "react";
import IGetVendorActivityReportDTO from "../../../../models/DTO/IGetVendorActivityReportDTO";
import IOnGetVendorActivityReportDTO from "../../../../models/DTO/IOnGetVendorActivityReportDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import IActivityReportDataRow from "../../../../models/IActivityReportDataRow";
import IOwTableCols from "../../../../models/IOwTableCols";
import ISupplierModel from "../../../../models/ISupplierModel";
import IUserUI from "../../../../models/IUserUI";
import PeriodTypesEnum from "../../../../models/PeriodTypesEnum";
import ReportPeriodType from "../../../../models/ReportPeriodTypeEnum";
import ReportTypeEnum from "../../../../models/ReportTypeEnum";
import UserService from "../../../../services/UserService";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import OwTable from "../../../shared/OwTable/OwTable";
import OwTitle from "../../../shared/OwTitle/OwTitle";
import IProcessed_Report from "../../../../models/IProcessed_Report";
import ReportPeriod from "../ReportPeriod/ReportPeriod";

type Props = {
    supplierModel: ISupplierModel;
    userModel: IUserUI;
    processedReport: IProcessed_Report;
};

export const VendorActivityReport: React.FC<Props> = (props) => {
    const [reportData, setReportData] = useState<IActivityReportDataRow[]>();
    const [startDate, setStartDate] = useState<string>();
    const [endDate, setEndDate] = useState<string>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    // called on initial load
    useEffect(() => {
        onVendorActivityReport(props.processedReport.report_data);
    }, []);

    // const loadReport = () => {
    //     let payload: IGetVendorActivityReportDTO = {
    //         userGuid: props.userModel.guid,
    //         userToken: props.userModel.token,
    //         supplierGuid: props.supplierModel.guid,
    //         // @ts-expect-error
    //         periodType: props.periodType,
    //         reportType: ReportTypeEnum.ACTIVITY_REPORT,
    //         startDate: props.startDate,
    //         endDate: props.endDate,
    //     };
    //
    //     props.socket.emit(EndpointsEnum.ReportVendorActivityReport, payload);
    // };

    const onVendorActivityReport = (data: IOnGetVendorActivityReportDTO) => {
        setReportData(data.data);
        setStartDate(data.periodStart);
        setEndDate(data.periodEnd);
        setIsLoading(false);
    };

    const activeAccountsCols: IOwTableCols[] = [
        {
            title: "name",
            valueProp: "name",
        },
        {
            title: "order_count",
            valueProp: "order_count",
        },
    ];

    const inactiveAccountsCols: IOwTableCols[] = [
        {
            title: "name",
            valueProp: "name",
        },
    ];

    if (isLoading) {
        return (
            <div className={"text-center"}>
                <OwTitle title={"loading_report_data"} leftIconName={"fas fa-circle-notch fa-spin"} />
            </div>
        );
    } else {
        return (
            <div className={"VendorActivityReport"}>
                <ReportPeriod className={"mb-3"} startDate={startDate} endDate={endDate} />

                {reportData?.map((dataRow, index) => {
                    return (
                        <div key={index} className={"mt-5"}>
                            <div>
                                <h4>{dataRow.salesPerson}</h4>
                            </div>

                            <div>
                                <OwLabel isBold={true} title={"active_accounts"} />
                                <OwTable
                                    columns={activeAccountsCols}
                                    dataSet={dataRow.activeAccounts}
                                    userModel={props.userModel}
                                    supplierModel={props.supplierModel}
                                    dataFetch={false}
                                    initialData={false}
                                />
                            </div>

                            <div>
                                <OwLabel isBold={true} title={"inactive_accounts"} />
                                <OwTable
                                    columns={inactiveAccountsCols}
                                    dataSet={dataRow.inActiveAccounts}
                                    userModel={props.userModel}
                                    supplierModel={props.supplierModel}
                                    dataFetch={false}
                                    initialData={false}
                                />
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
};
